import appApi, { CreateChartOfAccountRequest } from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const createChartOfAccountOperation = async (
  payload: CreateChartOfAccountRequest,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    if (!payload.accountCode.trim()) {
      toast.warn('יש להזין קוד חשבון');
      return;
    }
    if (payload.accountCode.length > 20) {
      toast.warn('קוד חשבון יכול להכיל עד 20 תווים');
      return;
    }
    if (!payload.accountName.trim()) {
      toast.warn('יש להזין שם חשבון');
      return;
    }
    if (payload.accountName.length > 100) {
      toast.warn('שם חשבון יכול להכיל עד 100 תווים');
      return;
    }
    if (!payload.accountType) {
      toast.warn('יש לבחור סוג חשבון');
      return;
    }
    if (payload.bankName && payload.bankName.length > 50) {
      toast.warn('שם הבנק יכול להכיל עד 50 תווים');
      return;
    }

    setLoading(true);
    const res = await appApi.createChartOfAccount(payload);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    toast.success('חשבון נוסף בהצלחה');
    onSuccess();
  } catch (error) {
    console.error('createChartOfAccountOperation failed:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
